export default function ExportButtons({ onCsv, onXlsx }) {
  return (
    <div className="export-buttons">
      {onCsv && <button type="button" className="button secondary" onClick={onCsv}>Export CSV</button>}
      {onXlsx && <button type="button" className="button secondary" onClick={onXlsx}>Export Excel</button>}
    </div>
  );
}
